import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';

interface LoaderProps {
  onComplete: () => void;
}

export default function Loader({ onComplete }: LoaderProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const barRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    document.body.classList.add('is-loading');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        onComplete: () => {
          document.body.classList.remove('is-loading');
          onComplete();
        },
      });

      if (prefersReduced) {
        gsap.set(rootRef.current, { display: 'none' });
        tl.set({}, {}, 0);
        return;
      }

      tl.to(titleRef.current, {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
      })
        .to(
          barRef.current,
          {
            scaleX: 1,
            duration: 1.4,
            ease: 'power2.inOut',
          },
          '-=0.4'
        )
        .to(
          rootRef.current,
          {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
            duration: 1.2,
            ease: 'power3.inOut',
          },
          '+=0.2'
        )
        .set(rootRef.current, { display: 'none' });
    }, rootRef);

    return () => {
      ctx.revert();
      document.body.classList.remove('is-loading');
    };
  }, [onComplete]);

  return (
    <div
      ref={rootRef}
      className="loader"
      style={{ clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }}
    >
      <div ref={titleRef} className="loader__title">
        San Juan
      </div>
      <div className="loader__bar" aria-hidden="true">
        <span ref={barRef} />
      </div>
    </div>
  );
}